import Model from './Model';

export default class Invoice extends Model {
    invoice_number;
    declaration_reference;
    invoice_date;
    rows;
    total;
    vat;
    total_with_vat;

    static fromJson(json) {
        let instance = super.fromJson(json);
        // Do the required prices divisions.
        instance.total /= 100;
        instance.vat /= 100;
        instance.total_with_vat /= 100;
        return instance;
    }
}



// WEBPACK FOOTER //
// ./src/models/Invoice.js